<template>
  <ul
    :class="[
      $style['list'],
      { [$style['list--striped']]: striped },
      { [$style['list--bordered']]: bordered },
      { [$style['list--no-wrapper-border']]: noWrapperBorder },
    ]">
    <slot />
  </ul>
</template>
<script setup>
defineProps({
  striped: {
    type: Boolean,
    default: false
  },
  bordered: {
    type: Boolean,
    default: false
  },
  noWrapperBorder: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" module>
.list {
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &--striped {
    & > :nth-child(even) {
      background-color: var(--grey-lightest);
    }
  }

  &--bordered {
    border: 1px solid var(--grey-light);
  }

  &--no-wrapper-border {
    border: 0;
  }
}
</style>
